export const DEFAULT = 'default';
export const NAVIGATION = 'navigation';

export const UI_LOAD = 'ui.load';
export const UI_ACTION = 'ui.action';
export const UI_ACTION_TOUCH = 'ui.action.touch';

export const APP_START_COLD = 'app.start.cold';
export const APP_START_WARM = 'app.start.warm';

/** Standalone app start transaction op (Span V2 / EAP). */
export const APP_START = 'app.start';

/** Extended app start span op — parent of user-instrumented app start work. */
export const APP_START_EXTENDED = 'app.start.extended';

export const UI_LOAD_INITIAL_DISPLAY = 'ui.load.initial_display';
export const UI_LOAD_FULL_DISPLAY = 'ui.load.full_display';
